import { useEffect } from "react";

/** Sets the tab title. Null leaves it to whoever else is setting it (an open section). */
export function useDocumentTitle(title: string | null): void {
  useEffect(() => {
    if (title === null) return;
    document.title = title ? `${title} · Border Rangers` : "Border Rangers";
  }, [title]);
}
